import {
  APP_SETTING_UPDATE_ENVIRONMENT_PROJECT_BEGIN,
  APP_SETTING_UPDATE_ENVIRONMENT_PROJECT_SUCCESS,
  APP_SETTING_UPDATE_ENVIRONMENT_PROJECT_FAILURE,
  APP_SETTING_UPDATE_ENVIRONMENT_PROJECT_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { toast } from 'react-toastify';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { getCookie, updateUserIpInCookie } from '../../../common/utils/api_utils';

export function updateEnvironmentProject(args = {}) {
  return async (dispatch) => {
    dispatch({
      type: APP_SETTING_UPDATE_ENVIRONMENT_PROJECT_BEGIN,
    });
    const { projectId, version, uuid } = args;
    const userIp = getCookie('userIp') || (await updateUserIpInCookie());
    const header = builderSurfaceJsonContentHeader(projectId, userIp);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.put(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/environments/${uuid}`,
        args.environment,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: APP_SETTING_UPDATE_ENVIRONMENT_PROJECT_SUCCESS,
              data: res.data,
            });
            toast.success('Updated Successfully !', {});
            resolve(res.data);
          } else {
            dispatch({
              type: APP_SETTING_UPDATE_ENVIRONMENT_PROJECT_FAILURE,
              data: { error: 'Failed' },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: APP_SETTING_UPDATE_ENVIRONMENT_PROJECT_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissUpdateEnvironmentProjectError() {
  return {
    type: APP_SETTING_UPDATE_ENVIRONMENT_PROJECT_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_UPDATE_ENVIRONMENT_PROJECT_BEGIN:
      return {
        ...state,
        updateEnvironmentProjectPending: true,
        updateEnvironmentProjectError: null,
      };

    case APP_SETTING_UPDATE_ENVIRONMENT_PROJECT_SUCCESS:
      return {
        ...state,
        updateEnvironmentProjectPending: false,
        updateEnvironmentProjectError: null,
        projectDetail: action.data,
      };

    case APP_SETTING_UPDATE_ENVIRONMENT_PROJECT_FAILURE:
      return {
        ...state,
        updateEnvironmentProjectPending: false,
        updateEnvironmentProjectError: action.data.error,
      };

    case APP_SETTING_UPDATE_ENVIRONMENT_PROJECT_DISMISS_ERROR:
      return {
        ...state,
        updateEnvironmentProjectError: null,
      };

    default:
      return state;
  }
}
